import React, { useState } from "react";
import { Flex, DatePicker, Button, Popconfirm, message } from "antd";
import dayjs from "dayjs";
import { useDeleteUploadDataByDateMutation } from "@/redux/services/uploadApi";

const dateFormat = "YYYY-MM-DD";

const DeleteUploadData = () => {
	const [selectedDate, setSelectedDate] = useState(
		dayjs().format(dateFormat)
	);

	const [deleteUploadDataByDate] = useDeleteUploadDataByDateMutation();

	const handleDelete = async () => {
		try {
			await deleteUploadDataByDate(selectedDate);
			message.success(`${selectedDate} data delete successful!`);
		} catch (error) {
			message.error("something went wrong");
			console.log("error", error);
		}
	};
	return (
		<Flex gap="large">
			<DatePicker
				style={{
					width: "200px",
					marginBottom: "30px",
				}}
				defaultValue={dayjs(selectedDate, dateFormat)}
				format={dateFormat}
				onChange={(date, dateString) => {
					setSelectedDate(dateString);
				}}
				allowClear={false}
			/>
			<div>
				<Popconfirm
					title="Delete the data"
					description="Are you sure to delete this data?"
					onConfirm={handleDelete}
					okText="Yes"
					cancelText="No"
				>
					<Button danger>Delete</Button>
				</Popconfirm>
			</div>
		</Flex>
	);
};
export default DeleteUploadData;
